import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

export const changeLinkButtonSx = {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgb(11, 59, 97)',
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    textTransform: 'none' as const,
    '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
    '&:active': { backgroundColor: 'transparent' },
    '&.Mui-focusVisible': { backgroundColor: 'transparent' }
}

export const PageWrapper = styled(Box)`
    background-color: rgb(209, 217, 226);
    min-height: 100vh;
    width: 100%;
`

export const PaymentLayoutGrid = styled(Box)`
    box-sizing: border-box;
    padding: 40px 20px;
    min-height: 50vh;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media screen and (min-width: 600px) {
        padding-left: 30px;
        padding-right: 30px;
    }

    @media screen and (min-width: 1200px) {
        padding-left: 16px;
        padding-right: 16px;
        display: grid;
        grid-template-columns: 770px 370px;
        gap: 22px;
        align-items: flex-start;
    }
`

export const SectionBox = styled(Box)`
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px 28px;
    background: #ffffff;
`

export const ModalContent = styled(Paper)`
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 32px 24px;
    border-radius: 12px;
    width: calc(100% - 40px);
    max-width: 770px;
    outline: none;

    @media screen and (min-width: 600px) {
        padding: 40px;
        width: 90%;
    }
`
